export const items = [
  [
         {
      name: 'Managed Service Providers ',
      icon: '/UserActivity.svg',
      link: '/partners/msps'
    },
    {
      name: 'Managed Security Service Providers',
      icon: '/RemoteManagement.svg',
      link: '/partners/mssps'
    },
       {
      name: 'Value-Added Resellers ',
      icon: '/PerformanceMonitoring.svg',
      link: '/partners/vars'
    },
  ]
];

export const label = 'Partners';
